// extracted by mini-css-extract-plugin
module.exports = {"section":"ExpressionSelector_section__3EbOw"};